import { Global, Tags, Team } from '@clearkit/icons';
import classnames from 'classnames';
import { CKContainerProps } from 'clearkit';

import { ProspectFilters } from '~/generated/graphql';

import { FilterInputChips } from './FilterInputChips';
import { FilterMultiPicker } from './FilterMultiPicker';
import { FiltersCompanies as FiltersCompaniesType } from './types';

type FiltersPersonProps = Omit<CKContainerProps, 'onChange'> & {
  filters: FiltersCompaniesType;
  prospectFilters: ProspectFilters;
  onChange: (value: FiltersCompaniesType) => void;
};

export const FiltersCompanies = ({
  className,
  filters,
  onChange,
  prospectFilters,
  ...rest
}: FiltersPersonProps) => {
  const updateFilters = (key: keyof FiltersCompaniesType) => (
    value: string[],
  ) => {
    const newFilters = { ...filters, [key]: value };
    onChange(newFilters);
  };

  return (
    <div
      {...rest}
      className={classnames('divide-y space-y-4 divide-gray-200', className)}
    >
      <FilterInputChips
        onChange={updateFilters('domains')}
        placeholder="Add domains"
        splitTokens={[',', ' ']}
        value={filters.domains ?? []}
      >
        <FilterInputChips.Icon>
          <Global />
        </FilterInputChips.Icon>
        <FilterInputChips.Title>Domains</FilterInputChips.Title>
        <FilterInputChips.HelpText>
          <strong>Pro tip:</strong> paste comma separated values or rows from a
          spreadsheet to add multiple domains at once.
        </FilterInputChips.HelpText>
      </FilterInputChips>
      <FilterMultiPicker
        className="pt-4"
        items={prospectFilters?.employeesRanges}
        onChange={updateFilters('employeesRanges')}
        value={filters.employeesRanges ?? []}
      >
        <FilterMultiPicker.Icon>
          <Team />
        </FilterMultiPicker.Icon>
        <FilterMultiPicker.Title>Employee Range</FilterMultiPicker.Title>
      </FilterMultiPicker>
      <FilterMultiPicker
        className="pt-4"
        items={prospectFilters?.industries}
        onChange={updateFilters('industries')}
        value={filters.industries ?? []}
      >
        <FilterMultiPicker.Icon>
          <Tags />
        </FilterMultiPicker.Icon>
        <FilterMultiPicker.Title>Industries</FilterMultiPicker.Title>
      </FilterMultiPicker>
      <FilterMultiPicker
        className="pt-4"
        items={prospectFilters?.companyTags ?? []}
        onChange={updateFilters('companyTags')}
        value={filters.companyTags}
      >
        <FilterMultiPicker.Icon>
          <Tags />
        </FilterMultiPicker.Icon>
        <FilterMultiPicker.Title>Tags</FilterMultiPicker.Title>
      </FilterMultiPicker>
    </div>
  );
};
